export const useDragAndDropStore = defineStore('drag-and-drop', () => {
  const state = reactive({
    isDragging: false,
    dragElementData: null as Record<string, any> | null,
    hoverZoneId: null as string | null,
    hoverIndex: null as number | null,
  })

  const reset = () => {
    state.isDragging = false
    state.dragElementData = null
    state.hoverZoneId = null
    state.hoverIndex = null
  }

  onMounted(() => {
    reset()
  })

  const setIsDragging = (value: boolean, data?: Record<string, any>) => {
    state.isDragging = value
    if (value)
      state.dragElementData = data ?? null
    else
      state.dragElementData = null
  }

  const setHoverZoneId = (value: string | null) => {
    state.hoverZoneId = value
  }

  const setHoverIndex = (value: number | null) => {
    state.hoverIndex = value
  }

  return {
    state,
    reset,
    setIsDragging,
    setHoverZoneId,
    setHoverIndex,
  }
})
